<div class="card-main decrease" *transloco="let t; prefix: 'fuelDashboard'">
  <div class="card-body card-barline-box" *ngIf="!isLoading; else noDataTitle">
    <div class="graph-up d-flex align-items-center justify-content-between" *ngIf="hasData(); else noDataTitle">
      <div class="graph-text">
        <h4>{{ t('widgets.fuelCostWithUnit', { unit: currencySymbol }) }}</h4>
        <app-graph-trend-icon [percentageChange]="percentageDifference" [formattedChange]="formatPercentChange()"
          [formatValue]="formatValue(value)" [isUptrendPositive]="isUptrendPositive()">
        </app-graph-trend-icon>
      </div>
      <div class="button-wrapper">
        <div class="common-drop-down no-filter dropdown">
          <button type="button" id="dropdown-button" data-bs-toggle="dropdown" aria-expanded="false">
            <img src="assets/images-fuel/threeDotBtnIcon.svg" alt="graph-icon" />
          </button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <a *ngFor="let option of dropdownOptions" class="dropdown-item" ngbDropdownItem
              (click)="onDropdownChanged(option)">
              {{option.label}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 100%;">
      @defer (on timer(100ms)) {
      @if (hasData()) {
      <app-multi-line-chart [data]="lineChartData" [chartConfig]="lineConfigs" [yConfig]="yAxisConfig"
        [xConfig]="xAxisConfig" [margin]="{ top: 30, right: 10, bottom: 0, left: 0, height: 145 }" />
      } @else {
      <div class="d-flex align-items-center justify-content-center no-data">
        <app-empty-state></app-empty-state>
      </div>
      }
      }
    </div>
  </div>
  <ng-template #noDataTitle>
    <div class="graph-text">
      <h4>{{ t('widgets.fuelCostWithUnit', { unit: currencySymbol }) }}</h4>
    </div>
  </ng-template>
  <div>
    <div class="card-loader" *ngIf="isLoading">
      <div class="spinner-border text-primary" role="status">
      </div>
    </div>
  </div>
</div>